// extracted by mini-css-extract-plugin
export default {"main":"advice_main__VPc8A","list":"advice_list__z4gk6"};